<template>
	<main class="mypage password_change">
		<UserMenu v-if="dispalyStore.isDesktop" />
		<FieldPasswordValidate
			v-model:password="member_password"
			v-model:passwordRe="member_password_re"
			:password_error="errors.member_password"
			:passwordRe_error="errors.member_password_re"
			@update:password="onChangeInputPw"
			@update:password-re="onChangeInputPwRe"
			@on-click-change-pw="onClickChangePw"
		/>
	</main>
</template>

<script setup lang="ts">
// core
import { useRouter } from 'vue-router';
// validation
import { useForm } from 'vee-validate';
import * as yup from 'yup';

// api
import { useMypageModifyPasswordApi } from '@/api/mypage';
import FieldPasswordValidate from '@/components/form/FieldPasswordValidate.vue';
// component
import UserMenu from '@/components/mypage/UserMenu.vue';
// constant
import { passRegex } from '@/constants/regex';
// constant
import {
	CHANGE_PW,
	COMPANY_TITLE,
	ERROR_PASSWORD_REQUIREMENTS,
	ERROR_PASSWORD_SAME_AS_CURRENT,
	ERROR_PASSWORDS_DO_NOT_MATCH,
} from '@/constants/title';
// store
import { useDisplayStore } from '@/stores/display';
import { usePopupStore } from '@/stores/popup';
import { useToastStore } from '@/stores/toast';

// -----variable-----
const dispalyStore = useDisplayStore();
const toastStore = useToastStore();
const popupStore = usePopupStore();
const router = useRouter();

// -----validation-----
const { errors, defineField, validate } = useForm({
	validationSchema: yup.object({
		member_password: yup.string().matches(passRegex, ERROR_PASSWORD_REQUIREMENTS),
		member_password_re: yup.string().oneOf([yup.ref('member_password')], ERROR_PASSWORDS_DO_NOT_MATCH),
	}),
	initialValues: {
		member_password: '',
		member_password_re: '',
	},
});

const [member_password] = defineField('member_password'); //패스워드
const [member_password_re] = defineField('member_password_re'); //패스워드 재확인

// -----api-----
const { mutateAsync: mypageModifyPassword } = useMypageModifyPasswordApi();

// -----function-----
const onChangeInputPw = (v: string) => {
	member_password.value = v;
};
const onChangeInputPwRe = (v: string) => {
	member_password_re.value = v;
};

const onClickChangePw = async () => {
	const { valid } = await validate();
	if (!valid) {
		return;
	}
	const res = await mypageModifyPassword({
		member_password: member_password.value,
	});
	if (res.data.success) {
		toastStore.openToast({
			subContent: COMPANY_TITLE,
			content: CHANGE_PW,
		});
		router.replace('/');
	} else {
		popupStore.openPopup({
			content: COMPANY_TITLE,
			subtext: ERROR_PASSWORD_SAME_AS_CURRENT,
		});
	}
};
</script>

<style lang="scss" scoped>
.password_change {
	margin-bottom: 7.2rem;
	@media screen and (max-width: 1280px) {
		padding-top: 4rem;
	}
}
</style>
